import { useDialog } from '@hprofits/ui';

export type UnsavedChangesAction = 'stay' | 'leave' | 'save-and-leave';

export type ConfirmUnsavedChangesOptions = Readonly<{
  title: string;
  description: string;
  leaveText: string;
  stayText: string;
  saveAndLeaveText?: string;
}>;

export const useUnsavedChangesDialog = () => {
  const dialog = useDialog();

  const confirm = (options: ConfirmUnsavedChangesOptions): Promise<UnsavedChangesAction | null> =>
    dialog<UnsavedChangesAction>({
      title: options.title,
      description: options.description,
      bodyPadded: true,
      actions: [
        { text: options.leaveText, variant: 'outline', action: 'leave' },
        ...(options.saveAndLeaveText === undefined
          ? []
          : [
              {
                text: options.saveAndLeaveText,
                variant: 'filled' as const,
                color: 'yellow' as const,
                action: 'save-and-leave' as const,
              },
            ]),
        { text: options.stayText, variant: 'filled', action: 'stay' },
      ],
    });

  return { confirm };
};
